/* eslint-disable react-hooks/rules-of-hooks */

import { GridColumns } from '@mui/x-data-grid-pro';
import { XGridDefaultColumn } from 'app/components/Common/XGrid/cells/XGridDefaults';
import { XGridOverflowCell } from '@AMIEWEB/Common/XGrid/cells/XGridOverflowCell';
import { XGridRadioCell } from '@AMIEWEB/Common/XGrid/cells/XGridRadioCell';
import i18next from 'i18next';

const OrdersSearchGridDefaultCell = {
  ...XGridDefaultColumn,
  flex: 0,
};
export const OrdersSearchGridViewInfo = (): GridColumns => [
  {
    ...OrdersSearchGridDefaultCell,
    field: 'orderIDselect',
    headerName: i18next.t('*'),
    align: 'center',
    sortable: false,
    width: 15,
    renderCell: XGridRadioCell,
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'orderId',
    headerName: i18next.t('search.globalSearch.order.gridTags.orderId'),
    width: 100,
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'facility',
    headerName: i18next.t('search.globalSearch.order.gridTags.facility'),
    width: 280,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'facilityStatus',
    headerName: i18next.t('search.globalSearch.order.gridTags.facilityStatus'),
    width: 130,
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'division',
    headerName: i18next.t('search.globalSearch.order.gridTags.division'),
    width: 90,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'city',
    headerName: i18next.t('search.globalSearch.order.gridTags.city'),
    width: 130,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'stateName',
    headerName: i18next.t('search.globalSearch.order.gridTags.state'),
    width: 90,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'skillsets',
    headerName: i18next.t('search.globalSearch.order.gridTags.skillSet'),
    width: 150,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'orderType',
    headerName: i18next.t('search.globalSearch.order.gridTags.type'),
    width: 90,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'orderPriority',
    headerName: i18next.t('search.globalSearch.order.gridTags.orderPriority'),
    width: 280,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'vmsReqNo',
    headerName: i18next.t('search.globalSearch.order.gridTags.vmsReqNo'),
    width: 150,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'positionsAvailable',
    headerName: i18next.t('search.globalSearch.order.gridTags.positionsAvailable'),
    width: 120,
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'maxFilesSent',
    headerName: i18next.t('search.globalSearch.order.gridTags.maxFilesSent'),
    width: 100,
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'filesPending',
    headerName: i18next.t('search.globalSearch.order.gridTags.filesPending'),
    width: 120,
    description: i18next.t('search.globalSearch.order.columnNameDescription.filesPending'),
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'filesOut',
    headerName: i18next.t('search.globalSearch.order.gridTags.filesOut'),
    width: 100,
    description:i18next.t('search.globalSearch.order.columnNameDescription.filesOut'),
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'mspClient',
    headerName: i18next.t('search.globalSearch.order.gridTags.mspClient'),
    width: 150,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'affiliate',
    headerName: i18next.t('search.globalSearch.order.gridTags.affiliate'),
    width: 150,
    renderCell: XGridOverflowCell()(),
  },

  {
    ...OrdersSearchGridDefaultCell,
    field: 'unit',
    headerName: i18next.t('search.globalSearch.order.gridTags.unit'),
    width: 150,
    renderCell: XGridOverflowCell()(),
  },

  {
    ...OrdersSearchGridDefaultCell,
    field: 'shifts',
    headerName: i18next.t('search.globalSearch.order.gridTags.shifts'),
    width: 150,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'paysGww',
    headerName: i18next.t('search.globalSearch.order.gridTags.paysGww'),
    width: 150,
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'guaranteedHours',
    headerName: i18next.t('search.globalSearch.order.gridTags.guaranteedHours'),
    width: 150,
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'expectedHours',
    headerName: i18next.t('search.globalSearch.order.gridTags.expectedHours'),
    width: 150,
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'reason',
    headerName: i18next.t('search.globalSearch.order.gridTags.reason'),
    width: 150,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'orderBillRate',
    headerName: i18next.t('search.globalSearch.order.gridTags.orderBillRate'),
    width: 150,
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'startdate',
    headerName: i18next.t('search.globalSearch.order.gridTags.startdate'),
    width: 100,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'endDate',
    headerName: i18next.t('search.globalSearch.order.gridTags.orderEndDate'),
    width: 100,
    renderCell: XGridOverflowCell()(),
  },

  {
    ...OrdersSearchGridDefaultCell,
    field: 'weeklyGrossPay',
    headerName: i18next.t('search.globalSearch.order.gridTags.weeklyGrossPay'),
    width: 150,
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'accountManager',
    headerName: i18next.t('search.globalSearch.order.gridTags.accountManager'),
    width: 145,
    renderCell: XGridOverflowCell()(),
  },

  {
    ...OrdersSearchGridDefaultCell,
    field: 'zipCode',
    headerName: i18next.t('search.globalSearch.order.gridTags.zip'),
    width: 120,
  },

  {
    ...OrdersSearchGridDefaultCell,
    field: 'businessRelationship',
    headerName: i18next.t('search.globalSearch.order.gridTags.businessRelationship'),
    width: 180,
    renderCell: XGridOverflowCell()(),
  },

  {
    ...OrdersSearchGridDefaultCell,
    field: 'dateEntered',
    headerName: i18next.t('search.globalSearch.order.gridTags.ordersAge'),
    width: 100,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'dateVerified',
    headerName: i18next.t('search.globalSearch.order.gridTags.dateVerified'),
    width: 100,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'covidVaccinationRequired',
    headerName: i18next.t('search.globalSearch.order.gridTags.covidVaccinationRequired'),
    width: 90,
    description: 'COVID Vaccination Required',
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'staffingVendor',
    headerName: i18next.t('search.globalSearch.order.gridTags.staffingVendor'),
    width: 145,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...OrdersSearchGridDefaultCell,
    field: 'techVendor',
    headerName: i18next.t('search.globalSearch.order.gridTags.techVendor'),
    width: 145,
    renderCell: XGridOverflowCell()(),
  },
];

export const SearchOrderGridColumnVisibilityModel = {
  orderId: true,
  facility: true,
  facilityStatus: true,
  division: true,
  city: true,
  state: true,
  skillSets: true,
  orderType: true,
  orderPriority: true,
  vmsReqNo: false,
  positionsAvailable: false,
  maxFilesSent: false,
  filesPending: false,
  filesOut: false,
  mspClient: false,
  affiliate: false,
  unit: false,
  shifts: false,
  paysGww: false,
  guaranteedHours: false,
  expectedHours: false,
  reason: false,
  orderBillRate: false,
  startDate: false,
  endDate: false,
  weeklyGrossPay: false,
  accountManager: false,
  zipCode: false,
  businessRelationship: false,
  dateEntered: false,
  dateVerified: false,
  covidVaccinationRequired: false,
  staffingVendor: false,
  techVendor: false,
};
